export const competenceObservationKeys = {
  all: ['competenceObservations'],

  lists: () => [...competenceObservationKeys.all, 'list'],

  classList: (classId?: number) => [...competenceObservationKeys.lists(), 'class', classId ?? null],

  studentList: (classId?: number, studentId?: number) => [
    ...competenceObservationKeys.lists(),
    'student',
    classId ?? null,
    studentId ?? null,
  ],

  studentScopedList: (params: {
    classId?: number | null;
    competenceId?: number | null;
    competenceIds?: readonly number[];
    from?: string;
    studentId?: number | null;
    to?: string;
  }) => [
    ...competenceObservationKeys.studentList(params.classId ?? undefined, params.studentId ?? undefined),
    'scope',
    params.competenceId ?? null,
    params.competenceIds ?? [],
    params.from ?? null,
    params.to ?? null,
  ],
};
